import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import StatusDataContext from '../../../contexts/StatusDataContext';
import Header from '../../headers/Header';
import makeData from '../../report/makeData'
import Table from './Table';
import { Page, Text, Svg, Polyline, Document, StyleSheet, Polygon, G, Circle } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import { TextField } from '@material-ui/core';
import ImageUploader from '../dataUploader/ImageUploader';
import PliesConfig from './PliesConfig';
import { List } from 'react-feather';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "140vh", alignContent: 'center', alignItems: 'center', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto'
  },
  button: {
    marginLeft: 'auto', marginRight: 'auto'
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  divButton: {
    marginLeft: 'auto', marginRight: 'auto',
    margin: '5',
    alignItems: 'center',
    justifyContent: 'center'
  },

}));

const styles = StyleSheet.create({
  page: { padding: 75 },
  textSmall: {
    fontSize: 12,
  },
  superSmall: {
    fontSize: 9,
  },
  smallest: {
    fontSize: 6,
  },
  title: {
    fontSize: 12,
    textAlign: 'center'
  }
});
function getSteps() {
  return ['Select Layers', 'Add Remark & Pictures', 'Plies Configuration', 'Schema Visualisation'];
}

function getStepContent(options, setOptions, remarks, setRemarks, setEntete, entete, numberplies, setNumberplies, angles, setAngles, open, handleSubmit, dialogValue, setDialogValue, toggleOpen, handleClose, remarksAuto, calculatedangles, setCalculatedangles, description, setDescription, activeCircle, setActiveCircle, activeDesc, setActiveDesc, step, information, comm, setComm, myimagelist, setMyimagelist, classes, setRemarksAuto) {
  switch (step) {
    case 0:
      return (<div><Table information={information} options={options} setOptions={setOptions} />

      </div>);
    case 1:
      return (
        <div className="stopwatch" >

          <br/><br/><br/>
          <span style={{ width: "100vh", alignContent: 'center', alignItems: 'center', textAlign: 'center' }}>
            <TextField
              style={{ width: '80vh', margin: '20px' }}
              multiline
              autoFocus
              margin="dense"
              id="name"
              value={comm}
              onChange={(e) => { setComm(e.target.value) }}
              label="Remark"
              type="text"
              variant="standard"
            /></span>
          <br /><br />
          <ImageUploader myimagelist={myimagelist} setMyimagelist={setMyimagelist} ></ImageUploader></div>
      )
    case 2:
      return (<PliesConfig setRemarksAuto={setRemarksAuto} remarks={remarks} setRemarks={setRemarks} setEntete={setEntete} entete={entete} numberplies={numberplies} setNumberplies={setNumberplies} angles={angles} setAngles={setAngles} open={open} handleSubmit={handleSubmit} dialogValue={dialogValue} setDialogValue={setDialogValue} toggleOpen={toggleOpen} handleClose={handleClose} remarksAuto={remarksAuto} calculatedangles={calculatedangles} setCalculatedangles={setCalculatedangles} description={description} setDescription={setDescription} activeCircle={activeCircle} setActiveCircle={setActiveCircle} activeDesc={activeDesc} setActiveDesc={setActiveDesc}></PliesConfig>)

    case 3:
      var secondGap = 0, beige = "#F5F5DC", grey = 'black';
      return (
        <div sclassName={classes.root}>
          <PDFViewer width='100%' height='700'>
            <Document style={{
              width: '500px',
              height: '100vh  !important'
            }}>
              <Page style={styles.page} size="A4">
                <Svg height={(30 * information[1].length + 35)} width="10000">
                  {information[1].map(({ label, value, color,numberLayers }, index) => {
                    return (
                      <>
                        <Polyline
                          points={"15," + (index * 30 + 10) + " 415," + (index * 30 + 10) + " 415," + (index * 30 + 35) + " 15," + (index * 30 + 35) + " 15," + (index * 30 + 10) + ""}
                          stroke={color}
                          strokeWidth={1}
                        />

                        <Polyline
                          points={"390," + (index * 30 + 12) + " 413," + (index * 30 + 12) + " 413," + (index * 30 + 33) + " 390," + (index * 30 + 33) + " 390," + (index * 30 + 12) + ""}
                          stroke={color}
                          fill={color}
                          fillOpacity='0.4'
                          strokeWidth={0.5}
                        />

                        <Text x="35" style={{ fontSize: 10 }} y={index * 30 + 28}>
                          {value}
                        </Text>
                        <Text x="60" style={{ fontSize: 10 }} y={index * 30 + 28}>
                          {label}
                        </Text>

                        <Text x="310" style={{ fontSize: 5 }} y={index * 30 + 28  }>
                          Number of layers
                        </Text>
                        <Text x="350" style={{ fontSize: 10 }} y={index * 30 + 28}>
                          {numberLayers}
                        </Text>


                      </>
                    );
                  })}

                  <Polyline
                    // cadre parent
                    points={"10,5 420,5 420," + ((30 * information[1].length) + 5) + " 10," + ((30 * information[1].length) + 5) + " 10,5 "}
                    stroke="grey"
                    strokeWidth={2}
                  />
                  <Polyline
                    // cadre parent
                    points={"10," + ((30 * information[1].length) + 5) + " 420," + (30 * information[1].length + 5) + " 430," + (30 * information[1].length + 35) + " 0," + (30 * information[1].length + 35) + " 10," + (30 * information[1].length + 5)}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Polyline
                    // cadre parent
                    points={"100," + (30 * information[1].length + 5) + " 100," + (30 * information[1].length + 10) + " 300," + (30 * information[1].length + 10) + " 300," + (30 * information[1].length + 5)}
                    strokeWidth={2}
                    stroke="black"
                  />
                  <Polyline
                    // cadre parent
                    points={"125," + (30 * information[1].length + 10) + " 125," + (30 * information[1].length + 15) + " 275," + (30 * information[1].length + 15) + " 275," + (30 * information[1].length + 10) + " "}
                    stroke="black"
                    strokeWidth={2}
                  />

                  <Polyline
                    // cadre parent
                    points={"150," + (30 * information[1].length + 15) + " 150," + (30 * information[1].length + 5 + 15) + " 250," + (30 * information[1].length + 20) + " 250," + (30 * information[1].length + 15) + " "}
                    stroke="black"
                    strokeWidth={2}
                  />
                  <Text x="30" style={{ fontSize: 12 }} y={30 * information[1].length + 25}>
                  Repair Patch
                  </Text>
                </Svg>
                <Text style={styles.title} >Figure: Vacuum Bag Diagram </Text>
                <Text style={{ fontSize: 12 }}  >{comm} </Text>

                <Svg height='175'>
                  {calculatedangles.slice(0, numberplies).map((row, indexe) => {
                    var index = indexe;
                    if (indexe >= 8) { index = indexe - 8; secondGap = 65; } else {
                      index = indexe;
                    }

                    return (
                      <>
                        <Circle
                          cx={30 + index * 56}
                          cy={secondGap + 75}
                          r="20"
                          fill={beige}
                          stroke="gray"
                        />

                        {index % 2 === 0 ?

                          <><Text x={15 + index * 56} y={secondGap + 107} style={styles.smallest} >{remarks[indexe]}</Text>
                          </> :

                          <><Text x={15 + index * 56} y={secondGap + 101} style={styles.smallest} >{remarks[indexe]}</Text>
                          </>
                        }


                        {Math.abs(angles[indexe]) > 90 && Math.abs(angles[indexe]) < 270 ?

                          <><Text x={22 + index * 56} y={secondGap + 70} style={styles.superSmall} >{angles[indexe]}</Text>
                            <Text x={37 + index * 56} y={secondGap + 70} style={styles.superSmall} >°</Text>
                          </> :

                          <><Text x={22 + index * 56} y={secondGap + 85} style={styles.superSmall} >{angles[indexe]}</Text>
                            <Text x={37 + index * 56} y={secondGap + 85} style={styles.superSmall} >°</Text>
                          </>
                        }
                        {indexe >= 8 ? <Text x={1 + index * 56} y={secondGap + 70} style={styles.superSmall} >{indexe + 1}</Text> : <Text x={1 + index * 56} y={secondGap + 70} style={styles.superSmall} >{indexe + 1}</Text>}
                        {indexe >= 8 ?
                          <Polygon fill={"black"} stroke="1" points={(30 + (index * 56)) + "," + (secondGap + 75) + " " + (calculatedangles[indexe][0] + (30 + (index * 56))) + "," + (calculatedangles[indexe][1] + secondGap + 75)} ></Polygon>

                          : <Polygon fill={"black"} stroke="1" points={(30 + (index * 56)) + "," + (secondGap + 75) + " " + (calculatedangles[index][0] + (30 + (index * 56))) + "," + (calculatedangles[index][1] + secondGap + 75)} ></Polygon>
                        }

                      </>
                    );
                  })}
                </Svg>
                <Text style={styles.title} >Figure: Vacuum Bag Lay Up Configuration</Text>


                <Text x="45" y={secondGap + 120} style={{ fontSize: 10 }}>Description of the process :</Text>
                {description ?
                  <>
                    <Text x="35" y={secondGap + 130} fill={grey} style={styles.superSmall} >{description.substring(0, 96)}</Text>
                  </> :
                  null
                }
                {description.length >= 96 ?
                  <>
                    <Text x="35" y={secondGap + 140} fill={grey} style={styles.superSmall} >{description.substring(96, 192)}</Text>
                  </> :
                  null
                }
                {description.length >= 192 ?
                  <>
                    <Text x="35" y={secondGap + 150} fill={grey} style={styles.superSmall} >{description.substring(192, 288)}</Text>
                  </> :
                  null
                }
                {description.length >= 288 ?
                  <>
                    <Text x="35" y={secondGap + 160} fill={grey} style={styles.superSmall} >{description.substring(288)}</Text>
                  </> :
                  null
                }
              </Page>
            </Document>
          </PDFViewer></div>);
    default:
      return 'Unknown step';
  }
}

export default function Schema({ options, setOptions, remarksAuto, setRemarksAuto, remarks, setRemarks, setEntete, entete, numberplies, setNumberplies, angles, setAngles, open, handleSubmit, dialogValue, setDialogValue, toggleOpen, handleClose, calculatedangles, setCalculatedangles, description, setDescription, activeCircle, setActiveCircle, activeDesc, setActiveDesc, information, comm, setComm, myimagelist, setMyimagelist }) {
  const [statusData, setStatusData] = React.useState([]);

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps();
  if (information[0] == null) {
    information[0] = 9
  }
  const isStepOptional = (step) => {
    //   return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };



  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Fragment>
      <div className={classes.root}>
        <Stepper activeStep={activeStep} style={{ borderRadius: 5, width: '90vh', height: '2px', marginLeft: 'auto', marginRight: 'auto' }} >
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepOptional(index)) {
              labelProps.optional = <Typography variant="caption">Optional</Typography>;
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div>

          <div>
            <Typography className={classes.instructions}>{getStepContent(options, setOptions, remarks, setRemarks, setEntete, entete, numberplies, setNumberplies, angles, setAngles, open, handleSubmit, dialogValue, setDialogValue, toggleOpen, handleClose, remarksAuto, calculatedangles, setCalculatedangles, description, setDescription, activeCircle, setActiveCircle, activeDesc, setActiveDesc, activeStep, information, comm, setComm, myimagelist, setMyimagelist, classes, setRemarksAuto)}</Typography>
            <div className={classes.divButton}>
              <Button className={classes.button} disabled={activeStep === 0} onClick={handleBack} >
                Back
              </Button>



              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={handleNext}
                disabled={activeStep === 3 || (activeStep === 2 && information[1].length === 0 && numberplies===0)}
              >

                {(function () {
                  if (activeStep === 0) {
                    return 'Add Remark & Pictures';
                  } else if (activeStep === 1) {
                    return 'Plies Configuration';
                  } else if (activeStep === 2 && information[1].length != 0 && numberplies!=0) {
                    return 'Schema Visualisation ';
                  }
                  else if (activeStep === 2 && information[1].length == 0 && numberplies==0) {
                    return '0 Plies/Vacuum-bag layers added ';
                  }
                   else {
                    return 'Finish'
                  }
                })()}
              </Button>
            </div>
          </div>

        </div>
      </div>
    </Fragment>
  );
}
